import React from "react";
import { Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { FileUploaderContainer } from "./styles";

export const FileUploader = ({ file, saveFile }) => {
  const onFilesAdded = (file) => {
    saveFile(file);
    return false;
  };

  return (
    <Upload
      accept=".csv, .xlsx, .xls"
      beforeUpload={onFilesAdded}
      maxCount={1}
      showUploadList={false}
    >
      <FileUploaderContainer>
        <Button icon={<UploadOutlined />}>Selecionar Arquivo</Button>
        <span className="file-name">
          {file ? file.name : "Nenhum arquivo selecionado"}
        </span>
      </FileUploaderContainer>
    </Upload>
  );
};
